import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TFUSelect from "../based/inputs/TFUSelect";
import Request from "../based/Request";
import PartnerServices from "../based/services/PartnerServices";
import upload from "./assets/upload.svg";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import PushingServices from "../based/services/PushingServices";
import PartnerColorModal from "./PartnerColorModal";

export const PartnerLogoPosition = {
    Bottom: 0,
    LeftSleeve: 1,
    RightSleeve: 2,
    Chest: 3,
    Back: 4,
};

export const ListPartnerLogoPosition = [
    {
        value: PartnerLogoPosition.Bottom,
        label: "Đáy áo",
    },
    {
        value: PartnerLogoPosition.LeftSleeve,
        label: "Tay trái áo",
    },
    {
        value: PartnerLogoPosition.Chest,
        label: "Ngực",
    },
    {
        value: PartnerLogoPosition.Back,
        label: "Lưng",
    },
];

const initData = {
    partnerId: 0,
    logoUrl: "",
    productThumbnail: "",
    position: 0,
    firstRange: 0,
    secondRange: 0,
};

function PartnerLogo({ partnerId }) {
    const [model, setModel] = useState({ ...initData });
    const [lstColor, setLstColor] = useState([]);
    const [colorDropdown, setColorDropdown] = useState(false);
    const [showModal, setShowModal] = useState(false);

    console.log("colorDropdown", colorDropdown);

    useEffect(() => {
        getColorDropdown();
    }, []);

    useEffect(() => {
        getModel(partnerId);
    }, [partnerId]);

    const getModel = async (id) => {
        const [err, data] = await PartnerServices.GetPartnerLogoAsync(id);
        if (!err && data) {
            setModel(data);
            setLstColor(data.listColor);
        } else {
            setModel({ ...initData, partnerId: id });
        }
    };

    const getColorDropdown = async () => {
        const [err, data] = await PushingServices.GetColorValue();
        if (!err && data) {
            setColorDropdown(data);
        } else {
            setColorDropdown([]);
        }
    };

    const handleSave = async (model) => {
        const [err, data] = await PartnerServices.CreateUpdatePartnerLogo(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Cập nhật thất bại");
        }
    };

    function _handleUploadImage(e) {
        return new Promise((resolve, reject) => {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.onloadend = function (e) {
                Request.UploadImage(file, 59).then((res) => {
                    if (res && res.data) {
                        return resolve(res.data.imageUrl);
                    } else {
                        return reject("Upload thất bại");
                    }
                });
            };
            reader.readAsDataURL(file);
        });
    }

    return (
        <React.Fragment>
            <Wrapper>
                <section className="table-image">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Màu</th>
                                <th>Logo</th>
                                <th>Hình mô tả vị trí</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {lstColor.map((item, index) => (
                                <tr key={index}>
                                    <td className="center">
                                        <span
                                            className="badge badge-item"
                                            style={{
                                                backgroundColor: item.colorCode,
                                                color: item.colorCode == "#ffffff" ? "black" : "white",
                                            }}
                                        >
                                            {item.colorName}
                                        </span>
                                    </td>
                                    <td
                                        className="center"
                                        style={{
                                            backgroundColor: "#DDD",
                                        }}
                                    >
                                        <div
                                            className="icon cursor-pointer"
                                            onClick={(e) => {
                                                document.getElementById(`upload-logo-${index}`).click();
                                            }}
                                        >
                                            {item.logo ? (
                                                <img src={item.logo} className="avatar" />
                                            ) : (
                                                <React.Fragment>
                                                    <img src={upload} alt="" />
                                                    <span>Upload</span>
                                                    <div className="normal">Tải lên PNG</div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                        <input
                                            type="file"
                                            name={`upload-logo-${index}`}
                                            id={`upload-logo-${index}`}
                                            onChange={(e) => {
                                                if (e.target.files[0].size > 3 * 1024 * 1024) {
                                                    Notify(NOTIFY.ERROR, "Lỗi", "File upload không được vượt quá 3MB");
                                                    return;
                                                }

                                                _handleUploadImage(e)
                                                    .then((url) => {
                                                        let lst = [...lstColor];
                                                        let item = lst[index];
                                                        item.logo = url;
                                                        setLstColor(lst);
                                                    })
                                                    .catch((err) => {});
                                            }}
                                            className="d-none"
                                        />
                                    </td>
                                    <td className="center">
                                        <div
                                            className="icon cursor-pointer"
                                            onClick={(e) => {
                                                document.getElementById(`upload-thumbnail-${index}`).click();
                                            }}
                                        >
                                            {item.thumbnail ? (
                                                <img src={item.thumbnail} className="avatar" />
                                            ) : (
                                                <React.Fragment>
                                                    <img src={upload} alt="" />
                                                    <span>Upload</span>
                                                    <div className="normal">Tải lên</div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                        <input
                                            type="file"
                                            name={`upload-thumbnail-${index}`}
                                            id={`upload-thumbnail-${index}`}
                                            onChange={(e) => {
                                                if (e.target.files[0].size > 500 * 1024) {
                                                    Notify(NOTIFY.ERROR, "Lỗi", "File upload không được vượt quá 3MB");
                                                    return;
                                                }

                                                _handleUploadImage(e)
                                                    .then((url) => {
                                                        let lst = [...lstColor];
                                                        let item = lst[index];
                                                        item.thumbnail = url;
                                                        setLstColor(lst);
                                                    })
                                                    .catch((err) => {});
                                            }}
                                            className="d-none"
                                        />
                                    </td>
                                    <td className="center">
                                        <button
                                            className="btn btn-danger"
                                            onClick={(e) => {
                                                let lst = [...lstColor];
                                                lst.splice(index, 1);
                                                setLstColor(lst);
                                            }}
                                        >
                                            Xóa
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="4">
                                    <button
                                        className="btn btn-custom"
                                        onClick={(e) => {
                                            setShowModal(true);
                                        }}
                                    >
                                        Thêm mới
                                    </button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </section>

                {/* <section className="upload-image">
                    <div className="upload-logo">
                        <label htmlFor="" className="required">
                            Upload Logo
                        </label>
                        <div className="upload">
                            <div
                                className="icon cursor-pointer"
                                onClick={(e) => {
                                    document.getElementById("upload-logo").click();
                                }}
                            >
                                {model.logoUrl ? (
                                    <img src={model.logoUrl} className="avatar" />
                                ) : (
                                    <React.Fragment>
                                        <img src={upload} alt="" />
                                        <span>Upload</span>
                                        <div className="normal">Tải lên PNG</div>
                                    </React.Fragment>
                                )}
                            </div>
                            <input
                                type="file"
                                name="upload-logo"
                                id="upload-logo"
                                onChange={(e) => {
                                    if (e.target.files[0].size > 3 * 1024 * 1024) {
                                        Notify(NOTIFY.ERROR, "Lỗi", "File upload không được vượt quá 3MB");
                                        return;
                                    }

                                    _handleUploadImage(e)
                                        .then((url) => {
                                            setModel({ ...model, logoUrl: url });
                                        })
                                        .catch((err) => {});
                                }}
                                className="d-none"
                            />
                        </div>
                    </div>
                    <div className="upload-logo">
                        <label htmlFor="" className="required">
                            Upload hình mô tả vị trí
                        </label>
                        <div className="upload">
                            <div
                                className="icon cursor-pointer"
                                onClick={(e) => {
                                    document.getElementById("upload-thumbnail").click();
                                }}
                            >
                                {model.productThumbnail ? (
                                    <img src={model.productThumbnail} className="avatar" />
                                ) : (
                                    <React.Fragment>
                                        <img src={upload} alt="" />
                                        <span>Upload</span>
                                        <div className="normal">Tải lên</div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                        <input
                            type="file"
                            name="upload-thumbnail"
                            id="upload-thumbnail"
                            onChange={(e) => {
                                if (e.target.files[0].size > 500 * 1024) {
                                    Notify(NOTIFY.ERROR, "Lỗi", "File upload không được vượt quá 500Kb");
                                    return;
                                }
                                _handleUploadImage(e)
                                    .then((url) => {
                                        setModel({ ...model, productThumbnail: url });
                                    })
                                    .catch((err) => {});
                            }}
                            className="d-none"
                        />
                    </div>
                </section> */}

                <section className="position">
                    <div className="position-dropdown">
                        <label htmlFor="">Vị trí logo</label>
                        <TFUSelect placeholder="Chọn vị trí" options={ListPartnerLogoPosition} value={model.position} onChanged={(value) => setModel({ ...model, position: +value, firstRange: 0, secondRange: 0 })} />
                    </div>
                    {model.position == PartnerLogoPosition.Bottom && (
                        <React.Fragment>
                            <div className="position-first-range">
                                <label htmlFor="">Cách đáy</label>
                                <div className="input-section">
                                    <input type="number" value={model.firstRange} onChange={(e) => setModel({ ...model, firstRange: +e.target.value })} />
                                    <span className="suffix">cm</span>
                                </div>
                            </div>
                            <div className="position-second-range">
                                <label htmlFor="">Cách phải</label>
                                <div className="input-section">
                                    <input type="number" value={model.secondRange} onChange={(e) => setModel({ ...model, secondRange: +e.target.value })} />
                                    <span className="suffix">cm</span>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                    {model.position == PartnerLogoPosition.LeftSleeve && (
                        <React.Fragment>
                            <div className="position-first-range">
                                <label htmlFor="">Cách đáy tay</label>
                                <div className="input-section">
                                    <input type="number" value={model.firstRange} onChange={(e) => setModel({ ...model, firstRange: +e.target.value })} />
                                    <span className="suffix">cm</span>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                    {model.position == PartnerLogoPosition.Chest && (
                        <React.Fragment>
                            <div className="position-first-range">
                                <label htmlFor="">Cách cổ</label>
                                <div className="input-section">
                                    <input type="number" value={model.firstRange} onChange={(e) => setModel({ ...model, firstRange: +e.target.value })} />
                                    <span className="suffix">cm</span>
                                </div>
                            </div>
                            <div className="position-second-range">
                                <label htmlFor="">Cách ngực</label>
                                <div className="input-section">
                                    <input type="number" value={model.secondRange} onChange={(e) => setModel({ ...model, secondRange: +e.target.value })} />
                                    <span className="suffix">cm</span>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                    {model.position == PartnerLogoPosition.Back && (
                        <React.Fragment>
                            <div className="position-first-range">
                                <label htmlFor="">Cách cổ</label>
                                <div className="input-section">
                                    <input type="number" value={model.firstRange} onChange={(e) => setModel({ ...model, firstRange: +e.target.value })} />
                                    <span className="suffix">cm</span>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                    <div className="form-group ml-3">
                        <label htmlFor="">Chiều ngang</label>
                        <div className="input-section">
                            <input type="number" value={model.width} onChange={(e) => setModel({ ...model, width: +e.target.value })} />
                            <span className="suffix">cm</span>
                        </div>
                    </div>
                    <div className="form-group ml-3">
                        <label htmlFor="">Chiều rộng</label>
                        <div className="input-section">
                            <input type="number" value={model.height} onChange={(e) => setModel({ ...model, height: +e.target.value })} />
                            <span className="suffix">cm</span>
                        </div>
                    </div>
                </section>
                <div className="list-button">
                    <button
                        className="btn btn-custom"
                        onClick={(e) => {
                            handleSave({ ...model, listColor: lstColor });
                        }}
                    >
                        Lưu
                    </button>
                </div>
            </Wrapper>
            <PartnerColorModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onSave={(colorCode, colorName) => {
                    let lst = lstColor ? [...lstColor] : [];
                    lst.push({ colorCode: colorCode, colorName: colorName, logo: "", thumbnail: "" });
                    setLstColor(lst);
                    setShowModal(false);
                }}
            />
        </React.Fragment>
    );
}

export default PartnerLogo;

const Wrapper = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    section.table-image {
        width: 50%;
        margin-right: 30px;
    }

    .list-button {
        width: 100%;
    }

    section.position {
        width: calc(50% - 42px);
    }

    section.upload-image {
        display: flex;
    }

    .upload {
        width: 140px;
        height: 140px;
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .upload-logo {
        margin: 10px 80px 10px 0;
    }

    .icon {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .upload .icon span {
        color: #a4a4a4;
        font-family: Roboto;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .upload .icon .normal {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin-top: 4px;
    }

    section.position {
        display: flex;
    }

    .position-dropdown {
        width: 180px;
        margin: 0 30px 0 0;
    }

    .position-first-range {
        width: 180px;
        margin: 0 30px 0 0;
    }

    .input-section {
        display: flex;
        align-items: center;
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 5px;
    }

    .input-section input[type="number"] {
        border: none;
        width: 100%;
    }

    .icon .avatar {
        width: 114px;
        height: 114px;
        object-fit: contain;
    }
`;
